export default "__VITE_ASSET__682fd612__"